import React from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { organizerHref } from '../cover/CoverOrganizers'
import ProducerProfileCard from './ProducerProfileCard'

// O co-organizador vem com a foto já como URL; o cartão lê o formato do perfil.
function asProfile(item) {
    return { ...item, photo: item.photo ? { path: item.photo, thumb: item.photo } : null }
}

/**
 * "Sobre o produtor" com todos os organizadores do evento: o produtor dono e,
 * em seguida, os produtores e estabelecimentos convidados que aceitaram. Cada
 * um com "Seguir" e "Ver eventos".
 */
export default function AboutOrganizers({ producer, coOrganizers = [] }) {
    return (
        <List>
            {producer?.id && <ProducerProfileCard data={producer} />}

            {coOrganizers.map(item => (
                <ProducerProfileCard
                    key={`${item.type}-${item.id}`}
                    data={asProfile(item)}
                    profileUrl={organizerHref(item.type, item.slug)}
                />
            ))}
        </List>
    )
}

const List = styled(Column)`
    gap: 24px;
`
